import React, { FC } from 'react';
import { Can } from '#/components/roles/Can';
import { NavigationLink } from '../components/NavigationLink';
import { Private } from '#/containers/router/routes/Private';
import { useAuth } from '#/contexts/AuthProvider';
import { useI18n } from '#hooks/useI18n';
import { SectionProps } from '#/containers/asideNavigation/Sections';

interface Props extends SectionProps {
}

export const Solvency: FC<Props> = ({ onClickItem, depth, isMobile }) => {
  const { t } = useI18n();

  return <Can hasRoles={['buildingManager', 'admin', 'agent']}>
    <NavigationLink to={Private.SOLVENCIES.route} icon="shield" title={t('asideNavigation.solvency')} onClick={onClickItem} depth={depth} isMobile={isMobile}/>
  </Can>;
};
